let routes = [
    {
      path: '/signalement-pratique-illegale',
      component: () => import('../views/SignalementPratiqueIllegale.vue'),
      props: true
    },
    {
      path: '/signalement-pratique-illegale/:step',
      component: () => import('../views/SignalementPratiqueIllegale.vue'),
      props: true
    }
  ]
  
  export default routes;